import React from "react";
import { useSelector } from "react-redux";
import PageContainer from "../custom/Page";
import EarningsReport from "./components/Reports/Earnings/EarningsReport";
import { getCurrentUserCommissionEarnings, getCurrentUserEarnings } from "../actions";

const EarningsReportCustomerPage = ({ history, match }) => {
  const currentUser = useSelector((state) => state.user.user.me);

  const fetchContractEarnings = React.useCallback(
    async (params) => {
      if (!currentUser?.id) return;
      return getCurrentUserEarnings(params);
    },
    [currentUser],
  );

  const fetchCommissionsEarnings = React.useCallback(
    async (params) => {
      if (!currentUser?.id) return;
      return getCurrentUserCommissionEarnings(params);
    },
    [currentUser],
  );

  return (
    <PageContainer>
      <EarningsReport
        user={currentUser}
        currentUser={currentUser}
        history={history}
        match={match}
        getContractEarnings={fetchContractEarnings}
        getCommissionsEarnings={fetchCommissionsEarnings}
      />
    </PageContainer>
  );
};

export default EarningsReportCustomerPage;
